import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { Constants } from 'src/app/constants';
import { AddQueueDialogComponent } from 'src/app/core/dialogs/add-queue-dialog/add-queue-dialog.component';
import { CheckboxCellRenderer } from 'src/app/core/grid/checkbox-cell-render';
import { GroupIDetailLevelService } from 'src/app/service/group-i/detail-level.service';
import { GroupiRouteService } from 'src/app/service/group-i/route-level.service';
import { GridDataService } from 'src/app/service/grid-data.service';
import { Router } from '@angular/router';
import { GroupIStateService } from 'src/app/service/groupi-state.service';

@Component({
  selector: 'app-groupidetails',
  templateUrl: './groupidetails.component.html',
  styleUrls: ['./groupidetails.component.scss'],
  standalone: false
})
export class GroupiDetailComponent implements OnInit {
  gridApi: any;
  icons;
  columnDefs;
  displayRowData = [];
  context: any;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  tAddViewComments: string = "";
  toggleAddViewComments: boolean = false;
  updatedRows = []
  toggleShowComplete: boolean;
  toggleShowIgnore: boolean;
  kpiId: any;
  alarmId: any;
  alarmTypeId: any;
  periodId: any;
  tierTitle: string = ""
  routeTitle: string = ""
  isCompleted: number;
  isIgnored: number;
  isAccessible = false;
  defaultColDef;
  successMessage
  errorMessage
  linkModule
  gridOptions;
  GroupI_WidgetsData = {
    id_TierPosition: null,
    id_Round: null,
    id_KPI: null,
    id_Alarm: null,
    alarm_type_id: null,
    title_Tier: null,
    title_Route: null,
    isCompleted: 0,
    isVerified: 0,
    isRoutes: 0,
    isAssigned: 0,
    assigneeId: null
  }
  PeriodLabel: string;
  selected_position_id: any;
  isStatus: any;
  shouldHide: boolean = true;
  mustHide: boolean = true;
  activate = 0;

  constructor(private readonly location: Location, private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly router: Router, private readonly groupIStateService: GroupIStateService,
    private readonly groupIDetailLevelService: GroupIDetailLevelService, private readonly gridDataService: GridDataService,
    public groupirouteService: GroupiRouteService, private readonly constants: Constants, public dialog: MatDialog) {
    this.context = {
      componentParent: this
    };

    this.defaultColDef = {
      suppressMovable: true, wrapText: true,
      filterParams: {
        newRowsAction: 'keep'
      },
      suppressHeaderFilterButton: true, suppressCellSelection: true
    }
    const GroupI_WidgetsData = localStorage.getItem('GroupI_WidgetsData');
    if (GroupI_WidgetsData) {
      this.GroupI_WidgetsData = JSON.parse(GroupI_WidgetsData);
    }

  }


  ngOnInit(): void {
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer)
    const data = JSON.parse(localStorage.getItem('gird'));
    this.selected_position_id = this.GroupI_WidgetsData.id_TierPosition;

    this.isStatus = data?.find(x => x.tierPosition == this.selected_position_id)?.RoundStatus  // NOSONAR
    if (this.isStatus == "CLOSED") {  // NOSONAR
      this.shouldHide = false;
    }
    if (this.isStatus != this.GroupI_WidgetsData.id_Round) { // NOSONAR
      this.shouldHide = false;
    } else {
      this.shouldHide = true;
    }

    let userID
    const userData = sessionStorage?.getItem('FGA');
    if (userData) {
      userID = JSON.parse(userData)?.user?.userPrincipalName;
    }
    if (this.GroupI_WidgetsData.isAssigned == 0 || this.GroupI_WidgetsData.assigneeId != userID) {  // NOSONAR
      this.mustHide = false;
    }

    this.gridOptions = this.gridDataService.newGetGridOptions();
    this.alarmTypeId = this.GroupI_WidgetsData.alarm_type_id.trim()
    this.tierTitle = this.GroupI_WidgetsData.title_Tier
    this.routeTitle = this.GroupI_WidgetsData.title_Route
    this.periodId = localStorage.getItem("selectedPeriodId");
    this.kpiId = this.GroupI_WidgetsData.id_KPI
    this.alarmId = this.GroupI_WidgetsData.id_Alarm
    this.PeriodLabel = localStorage.getItem('selectedPeriodValue')

    this.toggleShowComplete = this.toggleShowIgnore = false;
    this.isCompleted = this.isIgnored = 0;

    this.columnDefs = [

      {
        headerName: "Complete", field: "completed", width: 110,
        cellRenderer: CheckboxCellRenderer,
      },
      {
        headerName: "Ignore", field: "ignored", width: 100,
        cellRenderer: CheckboxCellRenderer,
      },
      {
        headerName: "Domicile", field: "domicile", sortable: true, unSortIcon: true,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true,

      },
      {
        headerName: "Route", field: "route", sortable: true, unSortIcon: true,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true,
      },
      {
        headerName: "Route Date", field: "routeDate", sortable: true, unSortIcon: true,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true, comparator: this.dateComparator
      },
      {
        headerName: "Supplier", field: "supplier", sortable: true, unSortIcon: true,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true
      },
      {
        headerName: "Plant", field: "plant",
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true
      },
      {
        headerName: "Dock", field: "dock", width: 100,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true
      },
      {
        headerName: "Order Date", field: "orderDate", sortable: true, unSortIcon: true,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true, comparator: this.dateComparator
      }, {
        headerName: "Order Sequence", field: "orderSequence", sortable: true, unSortIcon: true,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true
      },
      {
        headerName: "Over Time", field: "overtime",
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true
      }
    ];
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
      // filter: ''
    };
    this.refreshData();
    // this.checkRoles();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }

  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) {  // NOSONAR
      return 0;  
    }
    if (date1Number == null) {  // NOSONAR
      return -1;
    }
    if (date2Number == null) {  // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }


  async checkRoles() {
    await this.groupIStateService.getRoles();
    const roles = this.groupIStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
    //   if (userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin))
    //     this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // }
  }
  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }
  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") {  // NOSONAR
      this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length))
      this.activate = Number(this.displayRowData.length);
    }
    else {
      this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value))
      this.activate = Number(event.target.value);
    }
  }
  goToNexpage() { this.gridApi.paginationGoToNextPage(); }

  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage() }

  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); }

  goToLastPage() { this.gridApi.paginationGoToLastPage() }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  updateDisplayRowDataCB(parameter) {
    this.linkModule = ""
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    if (parameter == 'complete') { // NOSONAR
      this.toggleShowComplete = !this.toggleShowComplete;
    }
    else if (parameter == 'ignore') { // NOSONAR
      this.toggleShowIgnore = !this.toggleShowIgnore;
    }
    this.isCompleted = this.toggleShowComplete ? 1 : 0;
    this.isIgnored = this.toggleShowIgnore ? 1 : 0;
    this.groupIDetailLevelService.loadDataDetailLevel(this.periodId, this.kpiId, this.alarmId, this.isCompleted, this.isIgnored).subscribe(
      response => {
        this.displayRowData = response
        this.syncGridWithArrayData();

      }, error => {
        console.info(error)
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);

      }
    )

  }

  optimisedUpdateRowData(parameter, value) {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    console.info("Started the selection/deselection of all data ", new Date().getTime() / 1000)
    if ([5, 10, 20, 50].includes(this.activate)) { this.updateDisplayRowDataLink(parameter, value) }
    else if (Object.keys(this.gridApi?.getFilterModel()).length > 0) { this.updateFilteredRowData(parameter, value) }
    else {
      setTimeout(() => this.callSampleMethod(parameter, value), 100)
    }
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    console.info("Started the selection/deselection of all data ", new Date().getTime() / 1000)
  }

  updateDisplayRowDataLink(parameter, value) {
    console.info("entered updateDisplayRowDataLink method")
    if ((parameter == 'ignored' && this.alarmTypeId == 'W') || parameter == 'completed') { // NOSONAR
      const rowData = []
      let linkData = [];
      this.gridApi.forEachNodeAfterFilter(node => { rowData.push(node.data) });

      if (Object.keys(this.gridApi?.getFilterModel()).length > 0) { linkData = rowData; }
      else if (this.activate == this.rowCount) { linkData = this.displayRowData; } // NOSONAR
      else if (this.activate == 50) { // NOSONAR
        linkData = this.displayRowData.slice(0, 50)
      }
      else { linkData = this.gridApi.getRenderedNodes().map(obj => obj.data); }

      if (linkData.length > 0) {
        this.updatedRows = [];
        linkData.forEach((element, _index) => {
          element[parameter] = (value == 'all') ? 1 : 0; // NOSONAR
          this.displayRowData[this.displayRowData.findIndex(x => x.groupi == element.groupi)][parameter] = (value == 'all') ? 1 : 0; // NOSONAR
          const indexDisplayRowData = this.displayRowData.findIndex(x => x.groupi == element.groupi);
          if (indexDisplayRowData > -1) {
            if (parameter == 'completed' && element[parameter] == 1 && this.displayRowData[indexDisplayRowData]['ignored'] == 1) { // NOSONAR
              this.displayRowData[indexDisplayRowData]['ignored'] = 0
            }
            if (parameter == 'ignored' && element[parameter] == 1 && this.displayRowData[indexDisplayRowData]['completed'] == 1) { // NOSONAR
              this.displayRowData[indexDisplayRowData]['completed'] = 0
            }
          }
          const indexUpdatedRows = this.updatedRows.findIndex(y => y.groupi == element.groupi)  // NOSONAR
          if (indexUpdatedRows > -1) {
            this.updatedRows[indexUpdatedRows] = element;
          } else {
            this.updatedRows.push(element);
          }

        });
        this.gridApi?.setGridOption('rowData', this.displayRowData);
        this.rowCount = this.displayRowData.length;
      }
      this.linkModule = String(parameter + value)
    }
    else {
      this.errorMessage = this.constants.issuesIgnored;
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
    }
  }

  callSampleMethod(parameter, value) {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    console.info("entered callSampleMethod method")
    this.updatedRows = [];
    if (value == 'all') {  // NOSONAR
      if (parameter == 'completed') { // NOSONAR
        this.displayRowData = this.displayRowData.map((jsonObject) => ({ ...jsonObject, completed: 1, ignored: 0 }));
      } else {
        this.displayRowData = this.displayRowData.map((jsonObject) => ({ ...jsonObject, completed: 0, ignored: 1 }));
      }
    } else if (parameter == 'completed') {  // NOSONAR
      this.displayRowData = this.displayRowData.map((jsonObject) => ({ ...jsonObject, completed: 0, ignored: jsonObject.ignored }));
    } else {
      this.displayRowData = this.displayRowData.map((jsonObject) => ({ ...jsonObject, completed: jsonObject.completed, ignored: 0 }));
    }
    this.linkModule = String(parameter + value)
    this.updatedRows = this.displayRowData;

  }

  updateFilteredRowData(parameter, value) {
    console.info("entered filtered method")
    this.updatedRows = [];
    let tempFilteredData = []
    this.gridApi.forEachNodeAfterFilter(node => { tempFilteredData.push(node.data) });
    if (value == 'all') {  // NOSONAR
      if (parameter == 'completed') {  // NOSONAR
        tempFilteredData = tempFilteredData.map((jsonObject) => ({ ...jsonObject, completed: 1, ignored: 0 }));
      } else {
        tempFilteredData = tempFilteredData.map((jsonObject) => ({ ...jsonObject, completed: 0, ignored: 1 }));
      }
    } else if (parameter == 'completed') {  // NOSONAR
      tempFilteredData = tempFilteredData.map((jsonObject) => ({ ...jsonObject, completed: 0, ignored: jsonObject.ignored }));
    } else {
      tempFilteredData = tempFilteredData.map((jsonObject) => ({ ...jsonObject, completed: jsonObject.completed, ignored: 0 }));
    }
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.linkModule = String(parameter + value)
    const map2 = new Map(tempFilteredData.map(obj => [obj['groupi'], obj]));

    for (const object1 of this.displayRowData) {
      const object2 = map2.get(object1['groupi']);

      if (object2) {
        object1['completed'] = object2['completed'];
        object1['ignored'] = object2['ignored'];
      }
    }
    this.updatedRows = tempFilteredData;
  }

  syncGridWithArrayData() {
    this.tAddViewComments = ""
    if (this.displayRowData.length > 0) { this.tAddViewComments = this.displayRowData[0].comments }
    const model = this.gridApi?.getFilterModel();
    this.gridApi?.setGridOption('rowData', this.displayRowData)
    this.updatedRows = [];
    this.rowCount = this.displayRowData.length;
    this.gridApi?.setFilterModel(model);
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
  }


  refreshData() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.linkModule = ""
    this.groupIDetailLevelService.loadDataDetailLevel(this.periodId, this.kpiId, this.alarmId, this.isCompleted, this.isIgnored).subscribe(
      response => {
        this.displayRowData = response
        this.syncGridWithArrayData();


      }, error => {
        console.info(error)
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);
      }
    )

  }

  onCheckBoxSelectionChanged(data, fieldName) {
    const indexUpdatedRows = this.updatedRows.findIndex(y => y.groupi == data.groupi)  // NOSONAR
    data[fieldName] = data[fieldName] ? 1 : 0;
    if (indexUpdatedRows > -1) {
      this.updatedRows[indexUpdatedRows] = data;
    } else {
      this.updatedRows.push(data);
    }
    const indexDisplayRowData = this.displayRowData.findIndex(x => x.groupi == data.groupi);  // NOSONAR
    if (indexDisplayRowData > -1) {
      if (fieldName == 'completed' && data[fieldName] == 1 && this.displayRowData[indexDisplayRowData]['ignored'] == 1) {  // NOSONAR
        this.displayRowData[indexDisplayRowData]['ignored'] = 0
      }
      if (fieldName == 'ignored' && data[fieldName] == 1) {  // NOSONAR
        if (this.alarmTypeId == 'W') { this.displayRowData[indexDisplayRowData]['completed'] = 0 }  // NOSONAR
        else {
          this.displayRowData[indexDisplayRowData]['ignored'] = 0
          this.errorMessage = this.constants.issuesIgnored;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      }
    }
    this.linkModule = ""
    this.gridApi?.setGridOption('rowData', this.displayRowData)
  }

  goBack() {
    this.location.back();
  }

  saveDetails() {
    if (this.isStatus != "CLOSED") { // NOSONAR
      if (this.updatedRows.length > 0) {
        const tempUpdateRows = [];
        this.updatedRows.forEach(obj => {
          tempUpdateRows.push({
            groupIId: obj.groupi,
            completed: obj.completed,
            ignored: obj.ignored
          })
        })

        if (this.linkModule == 'ignoredall' && String(this.tAddViewComments).trim().length < 10) {  // NOSONAR
          this.errorMessage = this.constants.commentMandatoryDetailLevel;
          this.toggleAddViewComments = true;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, 20000);
          return;
        }
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)
        const textComments = this.tAddViewComments
        this.groupIDetailLevelService.saveRowsDetailLevel(this.kpiId, textComments, tempUpdateRows, this.alarmId).subscribe(
          response => {
            console.info(response)
            this.refreshData();
            this.successMessage = this.constants.APIDataSaved;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
            this.updateStatus();


          }, error => {
            console.info(error)
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            this.errorMessage = this.constants.APIErrorMessage;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
          }
        )
      } else {
        this.errorMessage = this.constants.noNewDataToUpdate;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);
        return;
      }
    }

  }
  verificationStatus() {

    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.groupIDetailLevelService.verificationStatus(3).subscribe(
      response => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        if (response == "Success") {  // NOSONAR
          this.successMessage = this.constants.APIVerficationSuccess;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        } else {
          console.info(response);
          this.errorMessage = this.constants.APIVerficationError;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      }, error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);
        console.info("VERIFICATION STATUS _ DETAIL ", error)
      }
    )
  }
  updateStatus() {
    this.groupIDetailLevelService.updateStatus(4).subscribe(
      _response => {
      }, error => {
        console.info("UPDATE STATUS _ DETAIL ", error)
      }
    )
  }
  AddToQueue(): void {

    const dialogRef = this.dialog.open(AddQueueDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '240px',
      data: {
        header: 'Add To Queue',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      if (result.event == 'SaveEvent') {  // NOSONAR
        if (result.data == "Success") {  // NOSONAR
          this.successMessage = this.constants.APIAddToQueueSuccess;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      }
    });
  }

  openRouteLevel(_val) {
    this.router.navigate(['route-level']);
  }



}

function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 10) {  // NOSONAR
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
